import { useMemo } from 'react';
import { USER_TYPES } from '@medflex/utils/constants';
import useUserProfile from './useUserProfile';

const usePermissions = () => {
  const { userProfile } = useUserProfile();
  const hasPatientAccess = useMemo(() => {
    if (userProfile)
      return userProfile.type === USER_TYPES.STAFF
        ? !!userProfile.attributes.patientAccessGrantedAt
        : true;
    return null;
  }, [userProfile]);
  const hasPhysicianAccess = useMemo(() => {
    if (userProfile) {
      return userProfile.type === USER_TYPES.STAFF
        ? !!userProfile.attributes.physicianAccessGrantedAt
        : true;
    }
    return null;
  }, [userProfile]);

  return {
    hasPatientAccess,
    hasPhysicianAccess,
  };
};

export default usePermissions;
